import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { map, Observable } from 'rxjs';
import { AssetsService } from '../../services';

@Component({
  selector: 'app-loading-animation',
  templateUrl: './loading-animation.component.html',
  styleUrls: ['./loading-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadingAnimationComponent implements OnInit {
  options$: Observable<AnimationOptions>;

  @Input()
  height: string;

  @Input()
  width: string;

  @Output()
  animationCreated = new EventEmitter();

  constructor(private assetsService: AssetsService) {}

  ngOnInit(): void {
    this.options$ = this.assetsService.getPrimaryLoadingAnimation().pipe(
      map((animationData) => ({
        animationData,
      }))
    );
  }
}
